/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { useAuth } from '../../providers/auth';

export function NotificationsPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/notifications`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const groupIds = user?.group?.id;

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Título' },
    { name: 'user_type', label: 'Notificação para' },
    { name: 'institution.name', label: 'Instituição' },
  ];

  return (
    <Box>
      <PageTitle>Notificações</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 6}
        loading={loading}
        rowActions={{ show: true, edit: groupIds !== 6, delete: groupIds !== 6 }}
        formatColum={[
          {
            field: 'institution.name',
            formatField: value => (value === undefined ? 'Todas' : value?.name),
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
